export const alternatingBackGround = key => {
  return {background: key % 2 === 0 ? '#f2f2f2' : '#fff'};
};